import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';

export const getExperienceLabel = (options: { label: string; value: any }[], value: any): string =>
  options.find((option) => option.value === value)?.label ?? '';

export type AnswerValue = 'Yes' | 'No' | null;

export type PropertyMethod = 'upload' | 'entity' | 'property';

export const PROPERTY_METHODS: { key: PropertyMethod; icon: typeof PublishOutlinedIcon; title: string; subtitle: string; recommended?: boolean }[] = [
  { key: 'upload', icon: PublishOutlinedIcon, title: 'Upload Track Record', subtitle: 'Fastest — XLSX or PDF' },
  { key: 'entity', icon: BusinessOutlinedIcon, title: 'Look Up by Entity', subtitle: 'Search records we already hold', recommended: true },
  { key: 'property', icon: RoomOutlinedIcon, title: 'Look Up by Property', subtitle: 'Search a single address' },
];

// uploadLabel: only questions with a license/document requirement show the
// upload prompt when answered "Yes" (Real Estate Experience never does).
export const QUESTIONS: { key: string; label: string; uploadLabel?: string }[] = [
  { key: 'generalContractor', label: 'Are you a General Contractor?', uploadLabel: 'Contractor license' },
  { key: 'broker', label: 'Are you a Real Estate Broker/Agent?', uploadLabel: 'Broker/agent license' },
  { key: 'previousExperience', label: 'Do you have any Real Estate Experience?' },
];
